import { decrypt } from 'components/encryptDecrpt';
import { atom, useAtomValue } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { IUser } from 'types/user';

const userAtom = atomWithStorage<string>('pulseUserInfo', '');

const useGetUser = () => {
    const user = useAtomValue(userAtom)
    try {
        const jsonString = decrypt(user);
        if (jsonString) {
            const parsed = JSON.parse(jsonString);
            if (typeof parsed === 'object' && parsed.id) {
                return parsed as IUser
            }
            else {
                return {} as IUser
            }
        }
        else {
            return {} as IUser
        }
    }
    catch (err) {
        return {} as IUser
    }
}

const checkCompanyCodeAtom = atom<boolean>(false);
const isLogoutAtom = atom<boolean>(false);

export type { IUser };
export { userAtom, useGetUser, checkCompanyCodeAtom, isLogoutAtom };